// =============================================================================
// 6. GenerateFindingsButton.js
// src/components/RPA/buttons/GenerateFindingsButton.js
// =============================================================================
import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

export default function GenerateFindingsButton({ docId, onDone, disabledHint }) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [includeManagementLetter, setIncludeManagementLetter] = useState(false);

  const handleClick = () => {
    setShowModal(true);
  };

  const handleSubmit = async () => {
    if (!docId) return;
    
    setLoading(true);
    try {
      const res = await axios.post(
        `${API_URL}/admin/rpa/docs/${docId}/balance-sheet/generate-findings`,
        { includeManagementLetter },
        { withCredentials: true }
      );
      
      console.log('[GENERATE_FINDINGS_BTN] Success:', res.data);
      setShowModal(false);
      if (onDone) onDone();
    } catch (err) {
      console.error('[GENERATE_FINDINGS_BTN] Failed:', err);
      alert(err.response?.data?.message || 'Findings generation failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={handleClick}
        disabled={loading || !!disabledHint}
        title={disabledHint || 'Generate final audit findings and opinion'}
        style={{
          background: loading ? '#9ca3af' : (disabledHint ? '#fca5a5' : '#6366f1'),
          color: 'white',
          border: 'none',
          padding: '4px 8px',
          borderRadius: 4,
          fontSize: 11,
          cursor: loading || disabledHint ? 'not-allowed' : 'pointer',
          fontWeight: 500
        }}
      >
        {loading ? 'Generating…' : 'Generate Findings'}
      </button>

      {showModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center',
          justifyContent: 'center', zIndex: 9999
        }}>
          <div style={{
            background: 'white', padding: 24, borderRadius: 12,
            maxWidth: 400, width: '90%', boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{ margin: '0 0 8px 0', fontSize: 16 }}>Generate Audit Findings</h3>
            <p style={{ margin: '0 0 16px 0', fontSize: 12, color: '#6b7280' }}>
              Compile all test results into final audit opinion and findings report.
            </p>
            
            <div style={{ marginBottom: 20 }}>
              <label style={{ 
                display: 'flex',
                alignItems: 'center',
                padding: 12,
                border: '1px solid #e5e7eb',
                borderRadius: 6,
                cursor: 'pointer',
                background: includeManagementLetter ? '#f0f9ff' : 'white'
              }}>
                <input
                  type="checkbox"
                  checked={includeManagementLetter}
                  onChange={(e) => setIncludeManagementLetter(e.target.checked)}
                  style={{ marginRight: 10 }}
                />
                <div>
                  <strong style={{ fontSize: 14 }}>Include Management Letter</strong>
                  <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>
                    Generate recommendations for internal control improvements
                  </div>
                </div>
              </label>
            </div>

            <div style={{ 
              padding: 12, 
              background: '#fef3c7', 
              border: '1px solid #fbbf24',
              borderRadius: 6,
              marginBottom: 16
            }}>
              <div style={{ fontSize: 12, color: '#92400e' }}>
                <strong>⚠️ Note:</strong> This will finalize the audit. Ensure all previous steps are complete.
              </div>
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowModal(false)}
                disabled={loading}
                style={{
                  padding: '8px 16px', borderRadius: 6, border: '1px solid #d1d5db',
                  background: 'white', cursor: 'pointer', fontSize: 13
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={loading}
                style={{
                  padding: '8px 16px', borderRadius: 6, border: 'none',
                  background: loading ? '#9ca3af' : '#6366f1', 
                  color: 'white', cursor: 'pointer',
                  fontWeight: 600, fontSize: 13
                }}
              >
                {loading ? 'Generating…' : 'Generate Report'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}